var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLogOut = function SvgIconLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icon_log out"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4d4d",
    d: "M7.715 19.142H4.858a1.43 1.43 0 0 1-1.429-1.429V6.285a1.43 1.43 0 0 1 1.429-1.429h2.857a1.429 1.429 0 1 0 0-2.857H4.858A4.286 4.286 0 0 0 .572 6.285v11.428a4.286 4.286 0 0 0 4.286 4.286h2.857a1.429 1.429 0 1 0 0-2.857M23.01 10.99l-5.714-5.714a1.43 1.43 0 1 0-2.024 2.023l3.279 3.275H9.143a1.429 1.429 0 1 0 0 2.857h9.411l-3.276 3.268a1.428 1.428 0 0 0 2.02 2.02l5.714-5.714a1.43 1.43 0 0 0-.003-2.015Z",
    "data-name": "Group 1787"
  }))));
};
export default SvgIconLogOut;